import { GET_API, POST_API, PUT_API, DELETE_API, PATCH_API } from "../../Functionalities/APIs";
import { clearRestaurantCache } from "../../Functionalities/restaurantCache";
import {
  adminDashboardOrderSummaryUrl,
  configurationsUrl,
  accountsAccountsUrl,
  configurationsParamUrl,
  branchDetailsUrl,
  accountsBranchBalanceUrl,
  accountsAllAccountsUrl,
} from "../../Constants/apiUrls";

export const OrderSummary = async (e, data, keyword, params) => {
    let path = adminDashboardOrderSummaryUrl;

    if (keyword == "get") {
        let result = GET_API("", params, path);
        // void 0

        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}

export const ManageSettings = async (e, data, keyword, params) => {
    let path = configurationsUrl;
    if (keyword == "get") {
        let result = GET_API("", params, path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}

export const ManageWallet = async (e, data, keyword, params) => {
     
    let path = accountsAccountsUrl;
    if (keyword == "get") {
        let result = GET_API("", params, path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}



export const ManageRestaurantCharge = async (e, data, keyword, params) => {
    let path = configurationsParamUrl;
    // let path = "/branch/details/"
    if (keyword == "get") {
        let result = GET_API("", params, path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }

    if (keyword == 'add') {
        var fdata = new FormData()
        fdata.append('param_name', data.param_name);
        fdata.append('new_param_value', data.charge);
        fdata.append('keyword', data.keyword);
        fdata.append('branch_id', data.branch_id);

        let result = POST_API(fdata, '', path)
        return await result.then((result) => {
            // void 0
            if (result) {
                clearRestaurantCache();
                return result;
            } else {
                return 0;
            }
        });
    }


    // if (keyword == 'patch') {
    //     var fdata = new FormData()
    //     fdata.append('param_name', data.param_name);
    //     fdata.append('new_param_value', data.charge);
    //     fdata.append('keyword', data.keyword);
    //     fdata.append('branch_id', data.branch_id);

    //     let result = PATCH_API(fdata, '', path)
    //     return await result.then((result) => {
    //         void 0
    //         if (result) {
    //             void 0
    //             return result;
    //         } else {
    //             return 0;
    //         }
    //     });
    // }
}

export const ManageRestaurantImage = async (e, data, keyword, params) => {
    // void 0
    let path = branchDetailsUrl;
    if (keyword == 'patch') {
        var fdata = new FormData()
        fdata.append('keyword', 'remove_image');
        fdata.append('image_ids', JSON.stringify(data));
        let result = PATCH_API(fdata, '', path)
        return await result.then((result) => {
            // void 0
            if (result) {
                clearRestaurantCache();
                return result;
            } else {
                return 0;
            }
        });
    }
}

export const ManageBalanceAmount = async (e, data, keyword, params) => {
    // void 0

    if (keyword == 'get') {
        let path = accountsBranchBalanceUrl;
        let result = GET_API("", params, path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
    if (keyword == 'add') {
        let path = accountsAllAccountsUrl;

        var fdata = new FormData();
        fdata.append('branch_id', data.branch_id);
        fdata.append('amount', data.amount);
        fdata.append('mode_of_payment', data.mode_of_payment);
        fdata.append('discription', data.discription);
        let result = POST_API(fdata, '', path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}

export const ManageFeatured = async (e, data, keyword, params) => {
    if (keyword == 'update') {
        let path = branchDetailsUrl;
        var fdata = new FormData();
        fdata.append('keyword', "is_featured");
        fdata.append('is_featured', data.is_featured);
        fdata.append('id', data.id);

        let result = PUT_API(fdata, '', path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                clearRestaurantCache();
                return result;
            } else {
                return 0;
            }
        });
    }

}

export const ManageBlock = async (e, data, keyword, params) => {
    if (keyword == 'patch') {
        let path = branchDetailsUrl;
        var fdata = new FormData();
        fdata.append('keyword', "block_branch");
        fdata.append('is_block', data.is_block);
        fdata.append('branch_id', data.id);

        let result = PATCH_API(fdata, '', path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                clearRestaurantCache();
                return result;
            } else {
                return 0;
            }
        });
    }

}

export const ManageActive = async (e, data, keyword, params) => {
    // let function_name = "Block"
    // void 0
    if (keyword == 'patch') {
        let path = branchDetailsUrl;
        var fdata = new FormData();
        fdata.append('keyword', "close_branch");
        fdata.append('is_closed', data.is_closed);
        fdata.append('branch_id', data.id);

        // for (var pair of fdata.entries()) {
        //     void 0
        //   }

        let result = PATCH_API(fdata, '', path);
        
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                clearRestaurantCache();
                return result;
            } else {
                return 0;
            }
        });
    }

}
